import { create, StateCreator } from "zustand"
import { devtools } from "zustand/middleware"
import { isDevtoolEnabled } from "@tm/utils"
import { withLenses } from "@dhmk/zustand-lens"

type OwnListsStore = {
    basePath: string
    setBasePath(path: string): void
}

export const createBasePathSlice: StateCreator<OwnListsStore, [["zustand/devtools", never]]> = (set) => ({
    basePath: "",
    setBasePath: (path: string) => set(() => ({ basePath: path })),
})

export const useOwnListsStore = create<OwnListsStore>()(
    devtools(
        withLenses((...args) => ({
            ...createBasePathSlice(...args),
        })),
        { name: "useOwnListsStore", enabled: true || isDevtoolEnabled() }
    )
)
